import React from 'react'

const AWSDataContext = React.createContext({
	loadMessages: [],
})

export default AWSDataContext